__turbopack_context__.v({
  "action": "NotFound-module-scss-module__dxCIXq__action",
  "code": "NotFound-module-scss-module__dxCIXq__code",
  "content": "NotFound-module-scss-module__dxCIXq__content",
  "description": "NotFound-module-scss-module__dxCIXq__description",
  "glow": "NotFound-module-scss-module__dxCIXq__glow",
  "page": "NotFound-module-scss-module__dxCIXq__page",
  "title": "NotFound-module-scss-module__dxCIXq__title",
});
